export default __webpack_public_path__ + "static/mamhashi_logo-bfc0d6351a42ea6e4e18525a3825fd17.svg";